import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { RolesService } from '../../infrastructure/services/roles.service';
import { Role } from 'app/infrastructure/model/classes/role.class';
import { AuthService } from "app/infrastructure/services/auth.service";
import { SOCRole } from 'app/infrastructure/model/classes/soc.role.class';

@Component({
  selector: 'sx-listado-roles',
  templateUrl: './soc-role-list.component.html',
})
export class SOCRoleListComponent implements OnInit {
  urlAdicional: string;
  roles: SOCRole[];
  buscar: any;

  constructor(
    private rolesService: RolesService,
    private aRoute: ActivatedRoute,
    private _router: Router,
    private _authService: AuthService,
  ) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {

      this.rolesService.getAllSOCRoles()
        .subscribe((response: SOCRole[]) => {
          this.roles = response;
        });
    });
  }

  toogleStatus(role: SOCRole) {
    const toggledStatus = role.status === Role.statusEnable ? Role.statusDisable : Role.statusEnable;
    role.status = toggledStatus;

    this.rolesService
      .setSOCRoleStatus(role);
  }

  volver() {
    this._router.navigate(['../'], { relativeTo: this.aRoute });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/soc-role/soc-role-list.component.ts